import { Link } from 'react-router-dom'

const sectionLinks = [
  { label: 'Adapt Workouts', to: '/#situational' },
  { label: 'Build Sessions', to: '/#manual-builder' },
  { label: 'Track Progress', to: '/#active-session' },
]

const legalLinks = [
  { label: 'Support', to: '/support' },
  { label: 'Privacy', to: '/privacy' },
  { label: 'Impressum', to: '/impressum' },
]

export function Footer() {
  return (
    <footer className="w-full pt-14 sm:pt-20 pb-8 sm:pb-10 bg-surface-container-low">
      <div className="flex flex-col md:flex-row justify-between items-center section-x max-w-7xl mx-auto gap-8 md:gap-6">
        <div className="text-center md:text-left">
          <Link
            to="/"
            className="font-headline font-bold text-on-surface text-2xl block mb-2 hover:text-primary transition-colors"
          >
            gymAhead
          </Link>
          <p className="text-on-surface-variant font-body text-sm tracking-wide">
            © {new Date().getFullYear()} beahead
          </p>
        </div>

        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-3 max-w-md md:max-w-none">
          {sectionLinks.map((link) => (
            <a
              key={link.label}
              href={link.to}
              className="text-on-surface-variant hover:text-secondary transition-colors duration-200 font-body text-sm tracking-wide"
            >
              {link.label}
            </a>
          ))}
          {legalLinks.map((link) => (
            <Link
              key={link.label}
              to={link.to}
              className="text-on-surface-variant hover:text-secondary transition-colors duration-200 font-body text-sm tracking-wide"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex gap-4">
          <a
            href="#"
            aria-label="Share"
            className="w-10 h-10 flex items-center justify-center rounded-full bg-surface-container-highest text-on-surface-variant hover:text-primary transition-all"
          >
            <span className="material-symbols-outlined text-xl">share</span>
          </a>
          <a
            href="#"
            aria-label="Favourite"
            className="w-10 h-10 flex items-center justify-center rounded-full bg-surface-container-highest text-on-surface-variant hover:text-primary transition-all"
          >
            <span className="material-symbols-outlined text-xl">star</span>
          </a>
        </div>
      </div>
    </footer>
  )
}
